import React from 'react';
import './App.css';
import global from './styles/global.css'
import CustomCard from '../src/components/card'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <p>This deployment is on Dev</p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <CustomCard
          title='Title Text'
          time='10:30'
          text='hey'
        />
      </header>
    </div>
  );
}

export default App;
